<template>
  <div class="premium-tab-content">
    <div class="premium-card-section mb-4">
      <div class="modal-section-title mb-4">
        <i class="fa fa-ship mr-2 text-primary"></i> Declaração de Importação (DI/ADIT)
      </div>
      
      <b-row class="mb-3">
        <b-col md="4">
          <b-form-group label="Número da DI" label-class="modal-label-premium">
            <b-form-input v-model="local.numeroDI" class="rounded-pill shadow-xs" placeholder="Ex: 12/1234567-8" @input="emit" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Data de Registro DI" label-class="modal-label-premium">
            <CecInputData v-model="local.dataDI" @input="emit" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Via de Transporte" label-class="modal-label-premium">
            <b-form-select v-model="local.viaTransporte" :options="viaTransporteOptions" class="rounded-pill shadow-xs custom-select-premium" @change="emit" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Local de Desembaraço" label-class="modal-label-premium">
            <b-form-input v-model="local.localDesembaraco" class="rounded-pill shadow-xs" placeholder="Porto/Aeroporto" @input="emit" />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="UF" label-class="modal-label-premium">
            <b-form-input v-model="local.ufDesembaraco" maxlength="2" class="rounded-pill shadow-xs text-center" placeholder="UF" @input="emit" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Data do Desembaraço" label-class="modal-label-premium">
            <CecInputData v-model="local.dataDesembaraco" @input="emit" />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div class="premium-card-section bg-soft-secondary p-3 rounded-lg border-secondary-light">
      <div class="modal-section-title mb-3">
        <i class="fa fa-info-circle mr-2"></i> Informações Adicionais
      </div>
      <b-row>
        <b-col md="6">
          <b-form-group label="Código do Exportador" label-class="modal-label-premium">
            <b-form-input v-model="local.codigoExportador" class="rounded-pill shadow-xs" placeholder="Cód. Identificação" @input="emit" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Vl. Adiantamento s/ Impostos" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.valorAFRMM"
              :options="autonumericOptions.valor"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import CecInputData from '@/components/Cec/CecInputData.vue'
import VueAutonumeric from 'vue-autonumeric'

export default {
  name: 'NfeProdutoImportacao',
  components: { CecInputData, VueAutonumeric },
  props: { value: { type: Object, default: () => ({}) } },
  data() {
    return {
      local: {},
      autonumericOptions: {
        valor: {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalPlaces: 2,
          minimumValue: '0',
          emptyInputBehavior: 'zero'
        }
      },
      viaTransporteOptions: [
        { value: '1', text: '1 - Marítima' },
        { value: '2', text: '2 - Fluvial' },
        { value: '3', text: '3 - Lacustre' },
        { value: '4', text: '4 - Aérea' },
        { value: '5', text: '5 - Postal' },
        { value: '6', text: '6 - Ferroviária' },
        { value: '7', text: '7 - Rodoviária' },
        { value: '8', text: '8 - Conduto / Rede Transmissão' },
        { value: '9', text: '9 - Meios Próprios' },
        { value: '10', text: '10 - Entrada / Saída Ficta' },
        { value: '11', text: '11 - Multimodal' },
        { value: '12', text: '12 - Vagão' }
      ]
    }
  },
  watch: {
    value: { handler(v) { this.local = v || {} }, immediate: true }
  },
  methods: {
    emit() {
      this.$emit('input', this.local)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeProdutoImportacao.vue